var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isPilotPlaying && !_vm.isPilotSelfBrowsingMode
    ? _c("div", { staticClass: "pilot-mask" })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }